"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IContinent = void 0;
var IContinent;
(function (IContinent) {
    IContinent["NorthAmerica"] = "North America";
    IContinent["SouthAmerica"] = "South America";
    IContinent["Europe"] = "Europe";
    IContinent["Africa"] = "Africa";
    IContinent["Asia"] = "Asia";
    IContinent["Oceania"] = "Oceania";
    IContinent["Antarctica"] = "Antarctica";
})(IContinent || (exports.IContinent = IContinent = {}));
//# sourceMappingURL=continent.js.map